import React from 'react';
import { KPMGSortAscendingIcon, KPMGSortDescendingIcon } from '../../../assets/icons';
import styled from 'styled-components';
import SortDirection from '../../../enums/sortDirection';
import { useTranslation } from 'react-i18next';
const StyledSpan = styled.span `
  cursor: pointer;
	position: relative;
	display: inline-block;
`;
const SortableHeaderCell = ({ title, isActive, direction, automationId, onClick }) => {
    const { t: translate } = useTranslation();
    const getIcon = () => {
        if (isActive) {
            return direction === SortDirection.Ascending ?
                <KPMGSortAscendingIcon /> : <KPMGSortDescendingIcon />;
        }
    };
    const titleValue = React.isValidElement(title) ? title : translate(title);
    return <StyledSpan data-automation-id={automationId} onClick={onClick}>{titleValue}{getIcon()}</StyledSpan>;
};
export default SortableHeaderCell;
